import { Field as ChakraField, Stack } from '@chakra-ui/react';
import * as React from 'react';

export interface FieldProps extends Omit<ChakraField.RootProps, 'label'> {
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  errorText?: React.ReactNode;
  optionalText?: React.ReactNode;
}

export const Field = React.forwardRef<HTMLDivElement, FieldProps>(
  (props, ref) => {
    const {
      label,
      children,
      helperText,
      errorText,
      optionalText,
      id,
      ...rest
    } = props;
    const hasHelperOrError = helperText || errorText;
    return (
      <ChakraField.Root ref={ref} {...rest}>
        {label && (
          <ChakraField.Label htmlFor={id}>
            {label}
            <ChakraField.RequiredIndicator fallback={optionalText} />
          </ChakraField.Label>
        )}
        {children}
        {hasHelperOrError && (
          <Stack gap={2} direction="column" align="stretch">
            {helperText && (
              <ChakraField.HelperText>{helperText}</ChakraField.HelperText>
            )}
            {errorText && (
              <ChakraField.ErrorText>{errorText}</ChakraField.ErrorText>
            )}
          </Stack>
        )}
      </ChakraField.Root>
    );
  },
);
Field.displayName = 'Field';
